import { render, staticRenderFns } from "./VpsUpgrade.vue?vue&type=template&id=1bc9f14f&"
import script from "./VpsUpgrade.vue?vue&type=script&lang=js&"
export * from "./VpsUpgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports